import { Button, message } from "antd";
import hasPermission from "../PermissionHocs/hasPermission";

const ButtonWithPermission = (props) => {
  const {
    children,
    actions,
    key,
    type,
    danger,
    size,
    color,
    icon,
    style,
    hideOnNoPermission = false,
    noPermissionText,
    noPermissionClassName,
    ...rest
  } = props;

  const accessible = hasPermission({ actions });

  const handleClick = (e) => {
    if (!accessible) {
      message.warning(noPermissionText || "Bạn không có quyền thực hiện thao tác này!");
      return;
    }

    if (!props.disabled && !props.isLoading && props.onClick) {
      props.onClick(e);
    }
  };

  if (hideOnNoPermission && !accessible) return null;

  return (
    <Button
      {...rest}
      type={type ?? "primary"}
      danger={danger ?? false}
      size={size}
      icon={icon}
      color={color}
      style={style}
      key={key}
      children={children}
      disabled={props.disabled || !accessible}
      onClick={handleClick}
      tabIndex={-1}
    />
  );
};

export default ButtonWithPermission;
